import { PageLoader as CommonLoader } from "@forge/common";
import React from "react";
import { useSelector } from "react-redux";

interface RootState {
  modalReducer: {
    pageLoader: boolean;
    content: string;
  };
}

const ScreenLoader = () => {
  const { pageLoader, content } = useSelector(
    (state: RootState) => state.modalReducer
  );

  return <CommonLoader content={content ? content : "Loading"} isLoading={pageLoader} />;
};

export default ScreenLoader;
